// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__3rYiD","author":"Table_author__3K1TO","authorImage":"Table_authorImage__AzkhD","unreadRow":"Table_unreadRow__22PYA"};